import { z } from 'zod';

/** URL search of /support-sessions: live sessions only unless `all` is set. */
export const supportSessionsSearchSchema = z.object({
  all: z.boolean().optional().catch(undefined),
});

export type SupportSessionsSearch = z.infer<typeof supportSessionsSearchSchema>;
